module.exports = __webpack_public_path__ + "static/media/wallet-no-item.3d71b7f3.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/wallet/wallet-no-item.png
// module id = 2141
// module chunks = 6